angular.module('zc.master.projects')

.directive 'zcProductLineLabel', () ->
  restrict: "E"
  template: """
    <span class="" ng-if="project.product_line === 'zenclerk'">{{ 'masterProjects.productLineLabel.zenclerk' | translate }}</span>
    <span class="" ng-if="project.product_line === 'zenclerk_lp'">{{ 'masterProjects.productLineLabel.lp' | translate }}</span>
    <span class="" ng-if="project.product_line === 'zenclerk_s'">{{ 'masterProjects.productLineLabel.lite' | translate }}</span>
  """
  scope:
    project: "="
  link: (scope, elem, attrs) ->



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.projects/product_line_label.directive.coffee